import { parseRequestHeaders } from '../helpers/parseHeaders';
import {
    QuickWebTokenRequest,
    ResponseMapperType,
    responseMapperMap,
    NormalizedQuickWebTokenResponse,
    TokenResponseMapper
} from './types';

export interface QuickWebApiConfig {
    quickWebTokenHandlerEndpoint: string;
    requestHeaders: HeadersInit | string;
    onBeforePaymentSubmit?: Function;
}

export const createQuickWebToken = <T>({
    quickWebTokenHandlerEndpoint,
    mapResponseType,
    responseMapper,
    requestHeaders,
    onBeforePaymentSubmit
}: QuickWebApiConfig & {
    responseMapper?: TokenResponseMapper<T>;
    mapResponseType?: ResponseMapperType | string;
}) => {
    const generateToken = async <T>(
        request: QuickWebTokenRequest
    ): Promise<NormalizedQuickWebTokenResponse> => {

        if (onBeforePaymentSubmit) {
            console.log('onBeforeSubmit');
            console.log(typeof onBeforePaymentSubmit)
            await onBeforePaymentSubmit();
        }

        const response = await fetch(quickWebTokenHandlerEndpoint, {
            method: 'POST',
            headers: parseRequestHeaders(requestHeaders),
            body: JSON.stringify(request)
        });

        if (!response.ok) {
            throw new Error('Failed to generate token');
        }

        const rawResponse = await response.json();

        if (typeof responseMapper === 'function') {
            return responseMapper(rawResponse);
        }

        if (mapResponseType) {
            const mapper = responseMapperMap[mapResponseType as ResponseMapperType];

            if (!mapper) {
                throw new Error(
                    `Invalid response mapper type: ${mapResponseType}`
                );
            }

            return mapper(rawResponse);
        }

        throw new Error(
            'No response mapper provided (responseMapper or mapResponseType required)'
        );
    };

    return {
        generateToken
    };
};

